<template lang="pug">
.brief
  .brief__table
    el-table(
      :data="data"
      @selection-change="handleSelectionChange"
    )
      el-table-column(
        type="selection"
        width="45"
        :selectable="checkboxStatus"
      )
      el-table-column(
        :render-header="renderHeader"
        align="left"
        show-overflow-tooltip
      )
        template(slot-scope="scope")
          div(style="display: flex; align-items: center")
            i.iconfont.icon-r(
              v-if="scope.row.is_storage"
              style="color: #3370d2; margin-right: 5px"
            )
            span(
              :class="{ offset: hasOffset(scope.row) }"
              style="width: 100%; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;"
            ) {{ scope.row.vendor_name_ch }}/{{scope.row.vendor_name}}
      el-table-column(
        :label="$t('联系人')"
        align="left"
        width="200"
      )
        template(slot-scope="scope")
          el-select(
            :disabled="scope.row.selectUser.status === 1 || scope.row.selectUser.status === 3"
            v-if="scope.row.selectUser"
            :value="scope.row.selectUser.user_id"
            @input="v => handleInput(v, scope.row)"
            :placeholder="$t('请选择账号')"
            style="width: 150px"
          )
            el-option(
              v-for="o in scope.row.user"
              :key="o.user_id"
              :value="o.user_id"
              :label="o.user_name"
            )
      el-table-column(
        :label="$t('状态')"
        align="left"
        width="110px"
        show-overflow-tooltip
      )
        template(
          slot-scope="scope"
          v-if="scope.row.selectUser"
        )
          span(
            v-if="scope.row.selectUser.status === 1"
            style="color: green"
          ) {{ $t('下发成功') }}
          span(v-else-if="scope.row.selectUser.status === 2")
            span(style="color: red") {{ $t('下发失败') }}
            span(
              @click="retry(scope.row)"
              style="color: #00a0e5; cursor: pointer; marginLeft: 10px"
            ) {{ $t('点击重试') }}
          span(v-else-if="scope.row.selectUser.status === 3") {{ $t('已拒绝') }}
          span(v-else) {{ $t('待下发') }}
      el-table-column(
        :label="$t('下发时间')"
        align="left"
        width="150"
        show-overflow-tooltip
      )
        template(
          slot-scope="scope"
        )
          span(v-if="scope.row.selectUser.status === 3") —
          span(v-else) {{ scope.row.selectUser.deliver_date | dateFormatter }}
      el-table-column(
        :label="$t('推荐方')"
        align="left"
        width="150px"
        show-overflow-tooltip
      )
        template(slot-scope="scope")
          span {{ scope.row.recommend_resource.split(',').map(o => $t(o)).join(',') }}
      el-table-column(
        :label="$t('操作')"
        align="left"
        :width="lang === 'en' ? 160 : 100"
      )
        template(slot-scope="scope")
          el-tooltip(
            v-show="scope.row.selectUser.remark"
            placement="top"
            :content="scope.row.selectUser.remark || '—'"
          )
            i.el-icon-warning(style="color:'#4AB7E2'")
          el-button(
            v-if="!scope.row.is_purchase_recommend"
            type="text"
            :disabled="!scope.row.can_reject"
            @click="handleReject(scope)"
          ) {{ $t('拒绝') }}
          el-button(
            v-else
            type="text"
            :disabled="!scope.row.can_delete"
            @click="handleDel(scope)"
          ) {{ $t('删除') }}

    reject-vendors-dialog(
      :showSubtitle="false"
      :visible="visible"
      :rejectedVendors="rejectVendor"
      @confirm="confirmReject"
      @cancel="visible = false"
    )
</template>

<script>
import axios from 'axios'
import { format4backend, dateFormatter } from '@/umcc/util'
import RejectVendorsDialog from '@/components/RejectVendorsDialog'

const retryDeliverVendor = params => {
  return axios.post('/management/campaign/retryDeliverVendor', format4backend(params))
}

export default {
  components: {
    RejectVendorsDialog
  },
  filters: {
    dateFormatter
  },
  props: {
    data: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      selectedList: [],
      visible: false,
      rejectVendor: [{
        id: null,
        vendor_name: ''
      }]
    }
  },
  computed: {
    lang () {
      return this.$store.state.common.lang
    },
    campaignId () {
      return this.$store.state.campaign.id
    }
  },
  methods: {
    renderHeader (h, { column, $index }) {
      return <span>
        <span style="fontWeight: 400; cursor: pointer; margin-right: 5px">
          {this.$t('供应商')}
        </span>
        <el-tooltip content={this.$t('R 标识核心供应商类型')} placement="top" style="margin-left: '5px'">
          <i class="el-icon-question"/>
        </el-tooltip>
      </span>
    },
    hasOffset (row) {
      if (this.data.some(d => d.is_storage) && !row.is_storage) return true
      return false
    },
    handleInput (id, row) {
      row.selectUser = row.user.find(o => o.user_id === id)
    },
    handleSelectionChange (val) {
      this.$emit('selectedChange', val)
    },
    handleDel (scope) {
      const loading = this.$loading()
      const params = {
        campaign_deliver_vendor_id: scope.row.campaign_deliver_vendor_id
      }
      axios.post('/management/campaign/deleteDeliverVendor', format4backend(params))
        .then(() => {
          loading.close()
          this.$emit('updateDeliverVendor')
        })
        .catch(() => {
          loading.close()
        })
    },
    async retry (row) {
      const params = {
        campaign_deliver_vendor_id: row.campaign_deliver_vendor_id,
        user_id: row.selectUser.user_id,
        task_name: this.$store.state.campaign.taskName
      }

      const loading = this.$loading()

      try {
        await retryDeliverVendor(params)
      } catch (err) {
        throw new Error(err)
      } finally {
        loading.close()
        this.$emit('retry')
      }
    },
    checkboxStatus (row, i) {
      return row.can_deliver ? 1 : 0
    },
    handleReject (scope) {
      this.visible = true
      this.rejectVendor = [{
        campaign_deliver_vendor_id: scope.row.campaign_deliver_vendor_id,
        vendor_name: scope.row.vendor_name,
        vendor_name_ch: scope.row.vendor_name_ch,
        refuse_reason: '',
        vendor_id: scope.row.vendor_id,
        user_id: scope.row.selectUser.user_id,
        recommend_resource: scope.row.recommend_resource
      }]
    },
    async confirmReject () {
      this.visible = false
      const params = {
        campaign_id: this.campaignId,
        campaign_deliver_vendor: {
          campaign_deliver_vendor_id: this.rejectVendor[0].campaign_deliver_vendor_id,
          vendor_id: this.rejectVendor[0].vendor_id
        },
        deliver_record: {
          user_id: this.rejectVendor[0].user_id,
          remark: this.rejectVendor[0].refuse_reason
        }
      }
      try {
        await axios.post('/management/campaign/rejectDeliverVendor', format4backend(params))
        this.$emit('updateDeliverVendor')
      } catch (err) {
        this.$message.error(this.$t('请填写拒绝原因'))
      }
    }
  }
}
</script>

<style lang="stylus">
.brief__brief
  > span:nth-child(1)
    margin-right 10px
  > span:nth-child(2)
    color: #00a0e5
    cursor pointer
  .el-icon-warning
    position absolute
    left 5px
    top 14px

</style>
